export enum TimePeriod {
  PAST = 'past', // completed, rejected etc
  PENDING = 'pending', // pending status
  UPCOMING = 'upcoming', // accepted but not completed
  PENDING_AND_UPCOMING = 'pending_and_upcoming', // combination of PENDING and UPCOMING
}